import type { BranchError, init, logEvent } from 'branch-sdk';

// branch-sdk touches `window` at module scope, so it must not be evaluated
// server-side (e.g. Bloom SSR). Load it lazily inside init, which only runs
// client-side.
type Branch = { init: typeof init; logEvent: typeof logEvent };

let branch: Branch | undefined;
let isBranchIoInitialized = false;

type OnError = (err: BranchError) => void;

export const initializeBranchIo = async (
  branchIoKey: string,
  onError?: OnError
) => {
  const mod = await import('branch-sdk');
  branch = (mod as { default?: Branch }).default ?? mod;
  branch.init(branchIoKey, {}, onError);
  isBranchIoInitialized = true;
};

interface CheckoutData {
  transaction_id: string;
}

export const trackBranchCheckout = (
  cartId: string,
  onError?: OnError
): boolean => {
  if (!isBranchIoInitialized || !branch) return false;
  const eventData: CheckoutData = { transaction_id: cartId };
  branch.logEvent('PURCHASE', eventData, undefined, undefined, onError);
  return true;
};
